import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// DELETE /api/admin/mdf/allocations/:id
//
// Replaces /app/admin/mdf/_actions.ts::removeAllocationAction. Pessimistic
// with confirmation modal at the page layer (the service enforces "no
// approved/spent requests against this allocation" and returns 400 with a
// human-readable error when violated; toast surfaces that to the admin).
type Vars = { id: string; fundId: string };

export function useRemoveAllocation() {
  const queryClient = useQueryClient();
  return useMutation<undefined, ApiClientError, Vars>({
    mutationFn: ({ id }) =>
      apiFetch<undefined>(`/admin/mdf/allocations/${id}`, {
        method: "DELETE",
      }),
    onSuccess: (_data, { fundId }) => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.mdf.fund(fundId) });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to remove allocation");
    },
  });
}
